import * as React from 'react'
import type { BlogPostType } from '../../services/contentfulPosts'
import { config } from 'react-awesome-styled-grid'
import { colors } from '@components/shared/colors'
import styled from 'styled-components'
import CategoryPillButton from '@components/blog/CategoryPillButton'
import { FadeInImage } from '@components/shared/FadeInImage'
import { contentfulLoader } from '../../services/images'
import { LinkWithUtms } from '../../actions/navigationActions'

type PropsType = {
  blogs: BlogPostType[],
  title?: string
}
export default function ThreeHorizontalPosts (props: PropsType): React.ReactNode {
  return (
    <PostsContainer>
      {props.blogs.map((blog: BlogPostType, index1: number): React.ReactNode => {
        const categories = (
          blog.categories || []
        ).map((cat: any, index: number): React.ReactNode => (
          <CategoryPillButton
            key={`${index1}-${index}-category-posts`}
            category={cat}
          />
        ))
        return (
          <PostContainer
            key={`${blog.id}-${index1}`}
            className={`post-container-${index1}`}
          >
            <ImageContainer>
              {blog.postPhoto && (
                <LinkWithUtms pathname={`/blog/${blog.slug}`}>
                  <PostImage>
                    <FadeInImage
                      loader={contentfulLoader}
                      src={blog.postPhoto.file.url}
                      width={blog.postPhoto.file.details.image.width}
                      height={blog.postPhoto.file.details.image.height}
                    />
                  </PostImage>
                </LinkWithUtms>
              )}
            </ImageContainer>
            <CategoryContainer>{categories}</CategoryContainer>
            <TitleContainer>
              <LinkWithUtms pathname={`/blog/${blog.slug}`}>
                <ClickableTitle>{blog.title}</ClickableTitle>
              </LinkWithUtms>
            </TitleContainer>
          </PostContainer>
        )
      })}
    </PostsContainer>
  )
}

const PostsContainer = styled.div<any>`
  display: flex;
  flex-direction: column;
  margin-bottom: 70px;

  ${(props: any): any => config(props).media.md`
    flex-direction: row;
    justify-content: space-between;
  `}

  ${(props: any): any => config(props).media.lg`
    margin-bottom: 90px;
  `}

  .post-container-0 {
    ${(props: any): any => config(props).media.md`
      margin-right: 32px;
    `}
  }

  .post-container-2 {
    margin-right: 0px;
    ${(props: any): any => config(props).media.md`
      margin-left: 32px;
    `}
  }
`
const PostContainer = styled.div<any>`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 45px;
  justify-content: center;
  ${(props: any): any => config(props).media.md`
    justify-content: flex-start;
    margin-bottom: 0px;
  `}
  &:hover {
    img {
      transform: scale(1.2);
    }
  }
`

const ImageContainer = styled.div<any>`
  width: 100%;
  margin-bottom: 7px;
  overflow: hidden;
  border-radius: 10px;
  display: inline;

  /* Safari border-radius + overflow: hidden + CSS transform fix */
  -webkit-mask-image: -webkit-radial-gradient(white, black); 
`
const PostImage = styled.div<any>`
  width: 100%;
  cursor: pointer;
  border-radius: 7px;
  img {
    transition: transform 0.5s ease;
  }
`
const CategoryContainer = styled.div<any>`
  margin-top: 15px;
  margin-bottom: 6px;
`
const TitleContainer = styled.div<any>``

const ClickableTitle = styled.div<any>`
  text-decoration: none;
  font-family: 'Queens Condensed Light';
  font-size: 28px;
  line-height: 33.6px;
  cursor: pointer;
  color: ${colors.sand};

  ${(props: any): any => config(props).media.md`
    font-size: 23px;
    line-height: 25px;
  `}

  ${(props: any): any => config(props).media.xl`
    font-size: 28px;
    line-height: 33.6px;
  `}
`
